import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../AuthProvider';

const Header = ({ onButtonClick }) => {

    const hasNotifications = false;

    const { userInfo, isLoading } = useContext(AuthContext);

    const formatExpiryDate = (dateString) => {
        if (!dateString) return 'N/A';

        const date = new Date(dateString);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    };

    // Check if the subscription has expired
    const isSubscriptionExpired = () => {
        if (!userInfo?.expire_date) return false;

        const expireDate = new Date(userInfo.expire_date);
        const today = new Date();

        return expireDate < today;
    };

    // Check if expiry date is within 30 days
    const isExpiryWithin30Days = () => {
        if (!userInfo?.expire_date) return false;

        const expireDate = new Date(userInfo.expire_date);
        const today = new Date();

        // Calculate the difference in milliseconds and convert to days
        const differenceInTime = expireDate.getTime() - today.getTime();
        const differenceInDays = differenceInTime / (1000 * 3600 * 24);

        return differenceInDays <= 30;
    };

    // Determine whether to show the alert
    const shouldShowAlert = () => {
        return userInfo?.expire_date && (isSubscriptionExpired() || isExpiryWithin30Days());
    };

    // Determine the alert class based on expiration status
    const getAlertClass = () => {
        return isSubscriptionExpired()
            ? 'btn btn-outline-danger btn-sm'
            : 'btn btn-outline-warning btn-sm';
    };


    return (
        <>
            <header className="top-header-area d-flex align-items-center justify-content-between">
                <div className="left-side-content-area d-flex align-items-center">

                    <div className="mobile-logo">
                        <a href="/"><img src="/admin_codebase/img/core-img/small-logo.png" alt="Mobile Logo" /></a>
                    </div>

                    <div className="flapt-triggers">
                        <div className="menu-collasped" id="menuCollasped" onClick={onButtonClick}>
                            <i className='bx bx-grid-alt'></i>
                        </div>
                        <div className="mobile-menu-open" id="mobileMenuOpen">
                            <i className='bx bx-grid-alt'></i>
                        </div>
                    </div>

                    <ul className="left-side-navbar d-flex align-items-center">
                        {/* <li className="hide-phone app-search">
                                <input type="text" className="form-control" placeholder="Search..." />
                                <span className="bx bx-search-alt"></span>
                            </li> */}
                    </ul>
                </div>

                <div className="right-side-navbar d-flex align-items-center justify-content-end">

                    {/* Free Trial and Upgrade Section */}
                    <div className="subscription-info d-flex align-items-center me-4">
                        <span className="free-trial-text me-3" style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>
                            <span className='text-center'>Expire on <strong>{formatExpiryDate(userInfo?.expire_date)}</strong></span>
                        </span>
                        {shouldShowAlert() && (
                            <a
                                href="/customer/upgrade"
                                className={getAlertClass()}
                                style={{
                                    fontWeight: '600',
                                    padding: '5px 15px',
                                    fontSize: '14px',
                                    borderRadius: '5px',
                                }}
                            >
                                Upgrade Now
                            </a>
                        )}


                    </div>

                    <div className="right-side-trigger" id="rightSideTrigger">
                        <i className='bx bx-menu-alt-right'></i>
                    </div>

                    <ul className="right-side-content d-flex align-items-center">
                        <li className="nav-item dropdown">
                            <button type="button" className="btn dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false"><i className='bx bx-bell bx-tada'></i> <span
                                    className="active-status"></span></button>
                            <div className="dropdown-menu dropdown-menu-right">

                                <div className="top-notifications-area">

                                    <div className="notifications-heading">
                                        <div className="heading-title">
                                            <h6>Notifications</h6>
                                        </div>
                                        <span>{hasNotifications ? '2' : '0'}</span>
                                    </div>

                                    <div className="notifications-box" id="notificationsBox">
                                        {hasNotifications ? (
                                            <>
                                                <a href="#" className="dropdown-item">
                                                    <i className='bx bx-shopping-bag'></i>
                                                    <div>
                                                        <span>Your order is placed</span>
                                                        <p className="mb-0 font-12">Consectetur adipisicing elit. Ipsa, porro!</p>
                                                    </div>
                                                </a>

                                                <a href="#" className="dropdown-item">
                                                    <i className='bx bx-wallet-alt'></i>
                                                    <div>
                                                        <span>Haslina Obeta</span>
                                                        <p className="mb-0 font-12">Consectetur adipisicing elit. Ipsa, porro!</p>
                                                    </div>
                                                </a>
                                            </>
                                        ) : (
                                            <div className="dropdown-item no-notifications">
                                                <div className="text-center py-3">
                                                    <i className='bx bx-bell-off mb-2' style={{ fontSize: '24px', color: '#aaa' }}></i>
                                                    <p className="mb-0">No notifications found</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li className="nav-item dropdown">
                            <button type="button" className="btn dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false"><img src="/admin_codebase/img/bg-img/person_2.jpg" alt="" /></button>
                            <div className="dropdown-menu profile dropdown-menu-right">

                                <div className="user-profile-area">
                                    <a href="/customer/my_profile" className="dropdown-item"><i className="bx bx-user font-15" aria-hidden="true"></i>
                                        My profile</a>

                                    <a href="/customer/changepassword" className="dropdown-item"><i className="bx bx-wrench font-15"
                                        aria-hidden="true"></i> Change Password</a>
                                    <a href="/customer/logout" className="dropdown-item"><i className="bx bx-power-off font-15"
                                        aria-hidden="true"></i> Sign-out</a>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </header>
        </>
    );
};

export default Header;